import { useTenantBranding } from "@/hooks/useTenantBranding";

/** Display name from `GET /tenant-branding/me` (`tenants.name`), cached in sessionStorage. */
export function useTenantName(): string {
  return useTenantBranding().tenantName;
}
